/**
 * YouTube player with custom events support.
 */
import React from "react";
import YTPlayer from "youtube-player";
import { dispatch } from "../../store";

import { UserEvents, UserEventsAPI } from "../../lib/userEventsAPI";

const ytStateNames = {
  "-1": "unstarted",
  0: "ended",
  1: "playing",
  2: "paused",
  3: "buffering",
  5: "video cued",
};

export class YouTubeIframeLoader extends React.Component {
  /**
   * Constructor.
   */
  constructor(props) {
    super(props);
    this.div = null;
    this.player = null;
    this.lastProgressTime = 0;
    this.getProgressInterval = null;
  }

  componentDidMount() {
    const { videoID } = this.props;
    this.player = YTPlayer(this.div, {
      videoId: videoID,
    });

    this.player.on("stateChange", function (event) {
      // console.log('event:', event);
      if (!ytStateNames[event.data]) {
        throw new Error(`Unknown state (${event.data}).`);
      }

      const eventName = ytStateNames[event.data];
      if (eventName === "playing") {
        dispatch(UserEventsAPI.send(UserEvents.YOUTUBE_VIDEO_STARTED));
      } else if (eventName === "paused") {
        dispatch(UserEventsAPI.send(UserEvents.YOUTUBE_VIDEO_PAUSED));
      } else if (eventName === "ended") {
        dispatch(UserEventsAPI.send(UserEvents.YOUTUBE_VIDEO_ENDED));
      }

      console.log(`YT State: ${eventName} (${event.data}).`);
    });

    setInterval(this.trackVideoProgress, 10 * 1000); // Every 10 seconds.
  }

  componentWillUnmount() {
    if (this.getProgressInterval !== null) {
      clearInterval(this.getProgressInterval);
      this.getProgressInterval = null;
    }
  }

  trackVideoProgress = () => {
    const promise = this.player.getCurrentTime();
    promise.then((value) => {
      value = Math.round(value);
      if (this.lastProgressTime !== value) {
        this.lastProgressTime = value;
        dispatch(
          UserEventsAPI.send(UserEvents.YOUTUBE_TIME_WATCHED, {
            seconds: value,
          })
        );
      }
    });
  };

  getDivID = () => {
    const { videoID } = this.props;
    return `video-${videoID}`;
  };

  saveRef = (ref) => {
    this.div = ref;
  };

  /**
   * Render method.
   */
  render() {
    return <div id={this.getDivID()} className="youtube-iframe" ref={this.saveRef} />;
  }
}
